import { getInfoErrorTO } from './getInfoErrorTO';

import {
  LOYALTY_ID,
  EMAIL_ID,
  PROMO_CODE,
} from 'contexts/CruiseSearchContext/constants';
import Cookies from 'js-cookie';
import { fetchTargetedOffers } from './fetchTargetedOffers';
import { getInputLoadTargetedOffers } from './getInputLoadTargetedOffers';

export const loadTargetedOffers = ({
  updateState,
  initialState,
  apolloClient,
  globalization,
  toogles,
  errorTargetedOffers,
  targetedOffers,
  targetedOffersLoading,
  targetedOffersLoaded,
  query,
  removeFromQualifiersSelecting,
  applyFilters,
  config,
}) => {
  const {
    enableTargetedOffersFeature,
    showMyOffers,
    enableEmailOnTargetedOffers,
  } = toogles;

  if (!enableTargetedOffersFeature || !showMyOffers) {
    return;
  }

  const { hasError } = getInfoErrorTO(errorTargetedOffers);

  if (
    Boolean(targetedOffers?.length) ||
    targetedOffersLoading ||
    targetedOffersLoaded ||
    Boolean(query[PROMO_CODE]) ||
    hasError
  ) {
    return;
  }

  const queryLoyalty = query[LOYALTY_ID.urlParam];
  const queryEmail = enableEmailOnTargetedOffers && query[EMAIL_ID.urlParam];
  const cookieLoyalty = Cookies.get(LOYALTY_ID.cookie);
  const cookieEmail =
    enableEmailOnTargetedOffers && Cookies.get(EMAIL_ID.cookie);

  if (!queryLoyalty && !queryEmail && !cookieLoyalty && !cookieEmail) {
    return;
  }

  const input = getInputLoadTargetedOffers({
    queryLoyalty: query[LOYALTY_ID.urlParam],
    queryEmail: query[EMAIL_ID.urlParam],
    cookieLoyalty: Cookies.get(LOYALTY_ID.cookie),
    cookieEmail: Cookies.get(EMAIL_ID.cookie),
  });

  const request = {
    updateState,
    inputData: input,
    globalization,
    initialState,
    apolloClient,
    query,
    toogles,
    targetedOffersLoading,
    removeFromQualifiersSelecting,
    applyFilters,
    config,
  };

  fetchTargetedOffers(request);
};
